import axios from 'axios';
import { GET_NOTIFICATIONS, GET_SPECIFIC_NOTIFICATION, ADD_NOTIFICATION, EDIT_NOTIFICATION, DELETE_NOTIFICATION, CLEAR_NOTIFICATIONS, NOTIFICATIONS_LOADING } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { INotification } from '../../types/interfaces';
import store from '../store';

export const getNotificationsByUserId = (userId: number) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: NOTIFICATIONS_LOADING
  });
  axios
    .get('/api/notifications/byUser', {...tokenConfig(getState), params: {userId}})
    .then(res =>
      dispatch({
        type: GET_NOTIFICATIONS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getNotificationById = async (id: number) : Promise<any> => {
  return new Promise((resolve, reject) => {
  axios
    .get('/api/notifications/specific', {...tokenConfig(store.getState), params: {id}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      reject(err)
    });
  });
};

export const notificationSeen = (id: number, unsee: number) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/notifications/seen', {id, unsee}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_NOTIFICATION,
        payload: res.data
      });
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const deleteNotification = (id: number, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .delete(`/api/notifications/${id}`, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: DELETE_NOTIFICATION,
        payload: id
      })
      callback(true)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const clearNotifications = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_NOTIFICATIONS
  })
};
